module.exports = __webpack_public_path__ + "images/133_160.jpg";